module.exports = __webpack_public_path__ + "img/logo_menu_dark.8be9211d.png";